import { regular } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect } from "react"
import { Heading3 } from "../typography/headings"
import { BodyTextRegular } from "../typography/text"
import { ButtonAction } from "../button/ButtonAction"

type Props = {
  header: string
  subtitle: string
  additionalSubtitleComponent?: React.ReactNode
  buttonText: string
  buttonOnClick: () => void | Promise<void>
}

export const ActionSuccessfulTemplate = ({
  header,
  subtitle,
  additionalSubtitleComponent,
  buttonOnClick,
  buttonText,
}: Props) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <div className="px-4 md:px-[100px] h-[75vh] flex flex-col items-center">
      <div className="w-[72px] h-[72px] bg-tag-green-bg rounded-full justify-center items-center flex mt-[100px] mb-8">
        <FontAwesomeIcon
          className="text-foreground-success"
          fontSize="40px"
          icon={regular("check")}
        />
      </div>

      <Heading3 className="mb-4">{header}</Heading3>
      <BodyTextRegular className="text-center text-foreground-base w-auto md:w-[440px]">
        {subtitle}
      </BodyTextRegular>
      {additionalSubtitleComponent && additionalSubtitleComponent}
      <ButtonAction
        className="max-w-[350px] my-8"
        size="large"
        onClick={buttonOnClick}
      >
        {buttonText}
      </ButtonAction>
    </div>
  )
}
